<template>
  <ul-scrollbar
    tag="div"
    ref="scrollbar"
    class="scrollbar-body"
    wrapStyle="max-height:100%;overflow-x:auto;"
  >
    <div v-for="item in list" :key="item.id" class="list">
      <div class="title">{{ item.title }}</div>
      <div class="content">
        <Editor
          v-model="item.content"
          v-if="activateId == item.id"
          @onChange="changeText($event, item)"
          :height="220"
          :placeholder="`请输入${item.title}`"
        >
        </Editor>
        <div
          v-else
          @click="inputFocus(item.id)"
          class="div-input"
          :class="{'placeholder': !item.content}"
        >
          <richtext :content="item.content || `请输入${item.title}`"></richtext>
        </div>
      </div>
    </div>
  </ul-scrollbar>
</template>

<script>
import Editor from 'pc/components/editor.vue'
import Richtext from 'pc/components/richtext.vue'
import { wordCount } from '@/utils/index'
export default {
  props: ['data'],
  components: {
    Editor,
    Richtext
  },
  data() {
    return {
      list: [
        {id: 1, title: '实验教学目标', content: ''},
        {id: 2, title: '实验原理', content: ''},
        {id: 3, title: '实验过程与方法', content: ''},
        {id: 4, title: '实验步骤', content: ''},
        {id: 5, title: '实验结果与结论', content: ''},
      ],
      activateId: null,
    }
  },
  created() {
    this.list[0].content = this.data.teachTarget
    this.list[1].content = this.data.principle
    this.list[2].content = this.data.processAndMethod
    this.list[3].content = this.data.step
    this.list[4].content = this.data.resultAndConclusion
  },
  methods: {
    inputFocus(id) {
      this.activateId = id
    },
    changeText(text, item) {
      item.content = text
    },
    validate() {
      for (let i = 0; i < this.list.length; i++) {
        if (wordCount(this.list[i].content) > 10000) {
          this.$message({
            message: `${this.list[i].title}最多10000字`,
            type: 'error'
          })
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.scrollbar-body {
  height: 422px;
  overflow: visible;
  ::v-deep {
    .ul-scrollbar__wrap {
      overflow-y: scroll;
      padding-right: 17px;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
    }
    .ul-scrollbar__bar.is-vertical {
      right: -8px
    }
  }
  .list {
    margin-bottom: 20px;
    .title {
      margin-bottom: 8px;
    }
    .div-input {
      border: 1px solid #e3e3e9;
      max-height: 90px;
      padding: 10px;
      overflow: hidden;
      overflow-y: auto;
      .richtext-container {
        font-size: 14px;
      }
      &.placeholder {
        color: #cbcbd1;
      }
    }
  }
}
</style>